<div *ngIf="active" class="tx-root" aria-hidden="true">
	<div *ngFor="let c of carriers" class="tx-carrier tx-carrier--preview" [class.is-fading]="c.fading" [ngStyle]="c.style">
		<div class="tx-carrier-surface"></div>
	</div>
</div>
